import React from 'react'
import './Footer.css'
import contactlogo1 from '../../assets/contactlogo1.png';
import contactlogo2 from '../../assets/contactlogo2.png';
// import fb from '/icon2.svg';
// import x from '/icon1.png';
// import linkedin from '/icon3.svg';
// import insta from '/icon4.svg';
import Form from '../form/Form';
const Footerwallet = () => {
    // const socials = [
    //     {
    //         id: 1,
    //         image: fb,
    //         title: "Facebook",
    //         url: "https://web.facebook.com/Floxypay"
    //     },
    //     {
    //         id: 2,
    //         image: x,
    //         title: "X", 
    //         url: "https://twitter.com/floxy_pay"
    //     },
    //     {
    //         id: 3,
    //         image: linkedin,
    //         title: "LinkedIn",
    //         url:"https://www.linkedin.com/company/floxypay/"
    //     },
    //     {
    //         id: 4,
    //         image: insta,
    //         title: "Instagram",
    //         url:"https://www.instagram.com/floxypayofficial/"
    //     },
    // ]
    return (
        <footer id='footer' className='divWrapper spacing'>
            <div className="container footerContainer">
                <div className="leftFooter">
                    <h1 className='footerHeading'>Let’s Get in Touch</h1>
                    <p className='footerPara'>Need help? Our support team is available 24/7 to provide fast, friendly, and reliable assistance whenever you need it.</p>
                    {/* <div className="socials">
                        {socials.map((item) => (
                            <a key={item.id} href={item.url} target="_blank" rel="noopener noreferrer" className='socialLink'>
                                <img src={item.image} alt={item.title} />
                            </a>
                        ))}
                    </div> */}
             <div className='contactlogos'>
              <p>Licence:</p>
                      <div className='contactlogo'>
      <a href="/floxylabs.pdf" download>
        <img
          src={contactlogo2}
          alt="Logo 2"
        />
      </a>
         <a href="/licenseletter.pdf" download>
        <img
          src={contactlogo1}
          alt="Logo 1"
        />
      </a>
    </div>
             </div>
                </div>
                <div className="rightFooter">
                    <Form />
                </div>
            </div>
        </footer>
    )
}

export default Footerwallet